var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEma3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Neutral"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.9996 22C43.9996 34.1501 34.1808 44 22.0685 44C9.95678 44 0.137939 34.1501 0.137939 22C0.137939 9.84991 9.95678 0 22.0685 0C34.1808 0 43.9996 9.84991 43.9996 22Z",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66217 22.0862C4.35299 9.93469 9.8102 3.66219 19.1638 0.172913C8.35792 1.5378 0 10.7891 0 21.9995C0 34.1496 9.81884 43.9995 21.9306 43.9995C23.9542 43.9995 25.913 43.7231 27.7733 43.2087C26.8674 43.3229 25.9432 43.4298 25.007 43.3821C14.9765 42.8701 4.97039 34.2325 4.66217 22.0862Z",
    fill: "#FFBB33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.42507 13.1827C7.42507 13.1827 8.17834 13.0618 9.2403 12.82C10.6753 12.493 12.6739 11.945 14.1406 11.1768C16.6909 9.83935 16.0326 13.4264 11.0613 14.446C6.08946 15.4651 6.13362 13.4307 7.42507 13.1827Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.9675 13.1827C35.9675 13.1827 35.2148 13.0618 34.1528 12.82C32.7173 12.493 30.7187 11.945 29.2525 11.1768C26.7018 9.83935 27.36 13.4264 32.3318 14.446C37.3027 15.4651 37.2585 13.4307 35.9675 13.1827Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.8778 30.9805H18.5151C17.5909 30.9805 16.8348 30.222 16.8348 29.2949C16.8348 28.3678 17.5909 27.6093 18.5151 27.6093H24.8778C25.8019 27.6093 26.5581 28.3678 26.5581 29.2949C26.5581 30.2215 25.8019 30.9805 24.8778 30.9805Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7368 20.8378C12.7368 18.7586 11.4439 17.073 9.84949 17.073C8.25462 17.073 6.96173 18.7586 6.96173 20.8378C6.96173 22.9169 8.25462 24.6025 9.84949 24.6025C11.4444 24.602 12.7368 22.9164 12.7368 20.8378Z",
    fill: "#802E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.1233 20.8378C35.1233 18.7586 33.8304 17.073 32.2361 17.073C30.6412 17.073 29.3483 18.7586 29.3483 20.8378C29.3483 22.9169 30.6412 24.6025 32.2361 24.6025C33.8304 24.602 35.1233 22.9164 35.1233 20.8378Z",
    fill: "#802E19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEma3);
export default __webpack_public_path__ + "static/media/ema3.76a49ccea3226dc416cc5718c277ce0a.svg";
export { ForwardRef as ReactComponent };